import RestBuilder from '../rest/RestBuilder';

const rest = new RestBuilder().mimeJson().successCodes([200]).build();

const postLeadKey = (leadKey, status) => rest({
  method: 'POST',
  path: 'api/v1/ratebroker/update-lead',
  entity: {
    leadKey,
    status
  }
});

const RatebrokerService = {
  postLeadKey
};

export default RatebrokerService;



/** WEBPACK FOOTER **
 ** ./src/services/RatebrokerService.js
 **/